module.exports = __webpack_public_path__ + "welcome3.6cf8c1c1164f99933556.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/assets/img/jpeg/welcome3.jpg
// module id = ../../../../../src/assets/img/jpeg/welcome3.jpg
// module chunks = 0